import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { APP_INFO } from '../../config/constants';

export default function Footer() {
  const year = new Date().getFullYear();
  const email = APP_INFO.contact.email;

  return (
    <footer className="bg-carbon-100 text-carbon-30 border-t border-carbon-90">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-14">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-5 group w-fit">
              <div className="w-9 h-9 bg-white border border-carbon-70 flex items-center justify-center p-1 group-hover:border-primary-400 transition-colors">
                <img src={logo} alt="Imarat Shariah" className="w-full h-full object-contain" />
              </div>
              <div>
                <span className="block text-white font-semibold text-sm leading-tight">Imarat Shariah</span>
                <span className="block text-[10px] text-primary-400 uppercase tracking-[0.14em] mt-0.5">Donation Platform</span>
              </div>
            </Link>
            <p className="text-sm text-carbon-40 leading-relaxed mb-6 max-w-xs">
              Empowering communities through transparent, secure, and impactful humanitarian giving.
            </p>
          </div>

          <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8 lg:gap-10">
            <div>
              <h4 className="text-white text-xs font-semibold uppercase tracking-widest mb-4">Platform</h4>
              <ul className="space-y-3">
                {[
                  { label: 'Projects', path: '/projects' },
                  { label: 'Dashboard', path: '/dashboard' },
                  { label: 'My Donations', path: '/donations/my-donations' },
                  { label: 'Receipts', path: '/receipts' },
                ].map(({ label, path }) => (
                  <li key={path}>
                    <Link to={path} className="text-xs text-carbon-40 hover:text-white transition-colors leading-relaxed">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white text-xs font-semibold uppercase tracking-widest mb-4">Support</h4>
              <ul className="space-y-3">
                {[
                  { label: 'Help Center', href: `mailto:${email}?subject=Help%20Request` },
                  { label: 'Privacy Policy', href: `mailto:${email}?subject=Privacy%20Inquiry` },
                  { label: 'Terms of Use', href: `mailto:${email}?subject=Terms%20Inquiry` },
                  { label: 'Contact Us', href: `mailto:${email}` },
                ].map(({ label, href }) => (
                  <li key={label}>
                    <a href={href} className="text-xs text-carbon-40 hover:text-white transition-colors leading-relaxed">{label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <h4 className="text-white text-xs font-semibold uppercase tracking-widest mb-4">Institution</h4>
              <div className="space-y-2 text-xs text-carbon-40 leading-relaxed">
                <p>Imarat Shariah<br />Bihar, Jharkhand & Odisha</p>
                <a
                  href={`mailto:${email}`}
                  className="text-primary-400 hover:text-primary-300 transition-colors break-all text-[11px]"
                >
                  {email}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-carbon-90 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[11px] text-carbon-50">
            © {year} Imarat Shariah. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-teal-400 animate-pulse-dot" style={{ borderRadius: 0 }} />
            <span className="text-[10px] text-carbon-50 uppercase tracking-widest">Systems Online</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
